import {file_post,post} from 'common/js/axios-helper';
import {PowerInfoApi} from "./constant/UrlMapper";


const host = '8882';
const host2 = '8883';
const host3="8881";


const list = (data) => {
    return post(PowerInfoApi.List, data, host, true);
};
const add = (data) => {
    return post(PowerInfoApi.Add, data, host, true);
};
const update = (data) => {
    return post(PowerInfoApi.Update, data, host, true);
};
const Delete = (data) => {
    return post(PowerInfoApi.Delete, data, host, true);
};
const selectone = (data) => {
    return post(PowerInfoApi.SelectOne, data, host, true);
};
const upload = (data) => {
    return file_post(PowerInfoApi.Upload, data, host2, true);
};




export default {list,add,update,Delete,selectone,upload}



// WEBPACK FOOTER //
// ./src/service/PowerInfoService.js